import React, { useState, useEffect } from "react";
import "../../styles/barcode.css";
import { SMSPage } from './SMSPage';
import { QRPage } from './QRPage';

export const DetailsContent = ({
  sourceBtn,
  productDetails,
  RBPObject,
  currentSegment,
  isProcessFeeApplicable,
  backToItemsPage,
}) => {
  const [loanId, setLoanId] = useState({});

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "PHP",
  });

  const getItemsList = () => {
    const items = productDetails.categories;
    return items
      .map((item) => item.categoryName)
      .reduce((acc, categoryName) => {
        return acc + ", " + categoryName;
      });
  };

  useEffect(() => {
    setLoanId((prev) => ({ ...prev, id: productDetails.id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Hide the PayHinga fee row when the product carries no VAS fee.
  useEffect(() => {
    if (productDetails.vasFlag === 0) {
      const timer = setTimeout(() => {
        const vasFeeId = document.getElementById("vasFeeId");
        if (vasFeeId) vasFeeId.style.display = "none";
      }, 500);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="shoping-details">
      <div className="row">
        {sourceBtn === "push-qr" ? (
          <QRPage loanId={loanId} effectiveMinDiff={productDetails.effectiveMinDiff} />
        ) : sourceBtn === "push-sms" && (
          <SMSPage loanId={loanId} backToItemsPage={backToItemsPage} />
        )}
        <div className={sourceBtn === "vip" ? "col-md-8 mb-3" : "col-md-4 mb-3"}>
          <div className="QR_product_info h-100">
            <div className="container">
              <div className="QR_info" >
                <div className="row" >
                  <div className="col">
                    <label>Items</label>
                  </div>
                  <div className="col">{getItemsList()}</div>
                </div>
                <div className="row">
                  <div className="col">
                    <label> Total price</label>
                  </div>
                  <div className="col">
                    <span>
                      {formatter.format(productDetails.total)}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label>Down payment</label>
                  </div>
                  <div className="col">
                    <span>
                      {formatter.format(
                        productDetails.downPaymentAmount
                      )}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label> Loanable amount</label>
                  </div>
                  <div className="col">
                    <span>
                      {formatter.format(
                        productDetails.loanableAmount
                      )}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label>Terms</label>
                  </div>
                  <div className="col">
                    {productDetails.tenure} months
                  </div>
                </div>
                {sourceBtn === "vip" && <div className="row">
                  <div className="col">
                    <label>Product Type</label>
                  </div>
                  <div className="col">
                    {productDetails.applicationType.productDescription}
                  </div>
                </div>}
                <div id="vasFeeId" className="row">
                  <div className="col">
                    <label> PayHinga fee </label>
                  </div>
                  <div className="col">
                    <span>
                      {formatter.format(
                        productDetails.vas.vasFee
                      )}
                    </span>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <label> Monthly installment</label>
                  </div>
                  <div className="col">
                    <span>
                      {formatter.format(
                        productDetails.monthlyAmount
                      )}
                    </span>
                  </div>
                </div>
                {RBPObject.status === "Y" && (
                  <div className="row">
                    <div className="col">
                      <label> Add-on rate</label>
                    </div>
                    <div className="col">
                      <span>
                        {currentSegment.addOnRate.toFixed(2)}%
                      </span>
                    </div>
                  </div>
                )}
                {(RBPObject.status === "Y" && (isProcessFeeApplicable && productDetails.processFee > 0)) ?
                  <div className="row">
                    <div className="col">
                      <label>Processing fee</label>
                    </div>
                    <div className="col">
                      <span>
                        {formatter.format(
                          isProcessFeeApplicable && productDetails.processFee > 0 ? productDetails.processFee / productDetails.tenure : 0
                        )}
                      </span>
                    </div>
                  </div>
                  : ""}

                {(sourceBtn !== "push-qr" && sourceBtn !== "vip") ? (
                  <>
                    <div className="row">
                      <div className="col">
                        <label>Name of Promoter</label>
                      </div>
                      <div className="col">
                        <span>
                          {JSON.parse(sessionStorage.getItem("userDetails")).firstName}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Mobile Number of Promoter</label>
                      </div>
                      <div className="col">
                        <span>
                          {JSON.parse(sessionStorage.getItem("userDetails")).mobile}
                        </span>
                      </div>
                    </div>
                  </>
                ) : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsContent;
